import { handleResponse, validateStatus } from '@ori/fetching';
import { getAtpClusters } from '@ori/global-api-client-react';
/**
 * Utility function for the client and the server to fetch ATP Cluster ID for current customer ID.
 * Allows aborting requests via custom AbortController.
 * Provides fallback for non-fatal errors.
 */
export var getAtpClusterId = async function getAtpClusterId(_ref) {
  var abortController = _ref.abortController,
    client = _ref.client,
    customerId = _ref.customerId;
  var response = await getAtpClusters(client, {
    customerId: customerId
  }, undefined, {
    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
    validateStatus: validateStatus
  });
  return handleResponse(response, {
    onError: function onError() {
      return undefined;
    },
    onSuccess: function onSuccess(_ref2) {
      var _collection$;
      var collection = _ref2.data.collection;
      return (_collection$ = collection[0]) === null || _collection$ === void 0 ? void 0 : _collection$.atpClusterId;
    }
  });
};
//# sourceMappingURL=getAtpClusterId.js.map